__turbopack_context__.v({
  "Applied": "_4owMfW_Applied",
  "Blocked": "_4owMfW_Blocked",
  "Discount": "_4owMfW_Discount",
  "GiftCards": "_4owMfW_GiftCards",
  "ListItem": "_4owMfW_ListItem",
  "ListMain": "_4owMfW_ListMain",
  "Notice": "_4owMfW_Notice",
});
